import { all } from "@redux-saga/core/effects";
import { proxiesSagas } from "modules/ProxyManager/services/Proxies/sagas";

export function* proxyManagerSagas() {
    yield all([
        proxiesSagas(),
    ]);
}
